import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1TimeSeriesEdit } from "./edit";
import { D1TimeSeriesNew } from "./new";
import { D1TimeSeriesTable } from "./table";

export default function D1TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1TimeSeriesEdit />} />
      <Route index element={<D1TimeSeriesTable />} />
      <Route path="/new" element={<D1TimeSeriesNew />} />
    </Routes>
  );
}
